export class FtpSita {
    identification: number;
    pathRPE: string;
    pathStamp: string;
    host: string;
    user: string;
    secret: string;
    dtCreation: Date;
    userCreation: string;
}
